import { SampleTypeEnum } from "../enums/sampleType.enum";

export class SamplingEquipment {
    id: string;
    name?: string;
    modelNumber: string;
    serialNumber: string;
    manufacturer: string;
    dateAcquired: string;
    status: number;
    sensorId: string;
    createdByUserId: string;
    organizationLevelId: string;
    sampleType: SampleTypeEnum;
    responsibleUserId: string;
    responsibleUserName: string;
    isDeleted: boolean;
    deletedByUserId: string;
    deletedDate?: string;
    equipmentCode: string;
}
